import React from 'react';

export default function FormElement(props) {

    const x = props.x;

	const id = x.wau.getId(props.wafId, props.id);
	const toolBar = (typeof props.toolBar === 'undefined') ? null : props.toolBar;
	const buttons = (typeof props.buttons === 'undefined') ? null : props.buttons;
	const reference = React.useRef(null);

	const disabled = (typeof props.disabled == 'undefined') ? false : props.disabled;
	const readOnly = (typeof props.readOnly == 'undefined') ? false : props.readOnly;

	const inputType = (typeof props.type === 'undefined') ? 'text' : props.type;
	const classes = (typeof props.classes === 'undefined') ? null : props.classes;
	const labelClasses = (typeof props.labelClasses === 'undefined') ? null : props.labelClasses;
	const children = (typeof props.children === 'undefined') ? null : props.children;
	const onChange = (typeof props.onChange === 'undefined') ? () => {} : props.onChange;
	const onFocus = (typeof props.onFocus === 'undefined') ? () => {} : props.onFocus;
	const onBlur = (typeof props.onBlur === 'undefined') ? () => {} : props.onBlur;
	const onPaste = (typeof props.onPaste === 'undefined') ? () => {} : props.onPaste;

	React.useEffect(() => {
		// console.log(props.wafId + ' - ' + id);
		x.waf.initField(
			props.wafId,
			props.id,
			reference,
			(typeof props.default === 'undefined') ? '' : props.default,
			(typeof props.name === 'undefined') ? props.id : props.name);
		x.waf.mandatory(props.wafId, props.id, (typeof props.mandatory === 'undefined') ? false : props.mandatory);
		// console.log('ID: ' + id );
	}, [props, reference, x]);

	function setValue(event) {
		switch (props.type) {
			case 'checkbox':
				x.waf.set(props.wafId, props.id, (event.target.checked) ? 1 : 0);
				break;
			default:
			// reference.current.value = event.target.value;
			x.waf.set(props.wafId, props.id, event.target.value);
		}
		x.waf[props.wafId].onFormChanged();
		onChange(event);
	}

	function makeElement() {
		var element;
		switch (inputType) {
			case 'button':
				element = makeButton();
				break;
			case 'text':
				element = makeInput();
				break;
			case 'search':
				element = makeSearch();
				break;
			case 'select':
				element = makeSelect();
				break;
			case 'checkbox':
				element = makeCheckbox();
				break;
			case 'message':
				element = makeMessage();
				break;
			case 'div':
				element = makeDiv();
				break;
			case 'textarea':
				element = makeTextArea();
				break;
			case 'image':
				element = makeImage();
				break;
			case 'posting':
				element = makePosting();
				break;
			default:
				element = makeInput();
		}
		return element;
	}

	function makeCheckbox() {
		const element =
			<div key={id} className="form-check mb-2 ">
				<label key={id + '-label'} htmlFor={id} className="form-check-label">{props.title}</label>
				<input key={id + '-input'} id={id} webappid={props.id} className="form-check-input " type="checkbox" ref={reference} disabled={disabled} onChange={setValue} onPaste={(e) => onPaste(e)} />
				{children}
			</div>
		return element;

	}

	function makeDiv() {
		const element =
			<div key={id} id={id} webappid={props.id} className="form-div mb-2" ref={reference} >
			</div>
		return element;

	}

	function makeButton() {
		const element =
			<button type="button" id={id} key={id} className="btn " onClick={props.onClick} ref={reference} >
				{props.title}
			</button>
		return element;

	}

	function makeImage() {
		const source = (typeof props.src === 'undefined') ? 'Backend/webapp.php?module=Public&task=Image&file=placeholder.png' : props.src;
		const element =
			<img key={id} id={id} webappid={props.id} className="form-img mb-2" src={source} ref={reference} alt={"image-" + id} />
		return element;

	}

	function makeInput() {
		const element =
			<div key={id} className="webapp-form-item mb-2">
				<label key={id + '-label'} htmlFor={id} className={` form-label ${labelClasses} `}>{props.title}</label>
				<span key={id + '-toolbar'} className="form-element-toolbar">{toolBar}</span>
				<input
					key={id + '-input'} 
					id={id}
					webappid={props.id} 
					type={inputType}
					ref={reference}
					disabled={disabled}
					readOnly={readOnly}
					className={` ${(disabled) ? "form-control-disabled" : "form-control"} ${classes} `}
					maxLength={props.maxLength}
					placeholder={(typeof props.placeholder === 'undefined') ? '' : props.placeholder}
					onChange={setValue}
					onFocus={(e) => onFocus(e)}
					onBlur={(e) => onBlur(e)}
					onPaste={(e) => onPaste(e)}
					autoComplete={(typeof props.autoComplete === 'undefined') ? 'off' : props.autoComplete}
				/>
				{children}
				{buttons}
			</div>
		return element;

	}

	function makeMessage() {
		const element =
			<div key={id} className="webapp-form-item mb-2">
				<input
					key={id + '-input'} 
					id={id}
					webappid={props.id} 
					type={inputType}
					ref={reference}
					disabled={true}
					className={` form-control-message ${classes} `}
				/>
			</div>
		return element;

	}

	function makeSearch() {
		const element =
			<div key={id} className="search-element">
				<input key={id + '-input'} type="text" className="form-control rounded-pill" ref={reference} disabled={disabled} id={id} webappid={props.id} onChange={setValue} placeholder="Suchen" />
				{(typeof props.toolBar !== 'undefined') ? props.toolBar : null}
			</div>

		return element;

	}

	function makePosting() {
		const element =
			<div key={id} className='element-posting'>
				<i key={id + '-posting'} className="bi bi-pencil-fill context-menu-icon" ref={reference} id={id} webappid={props.id} dangerouslySetInnerHTML={{ __html: (typeof props.default == 'undefined') ? '' : props.default }} />
			</div>
		return element;
	}

	function makeSelect() {
		const element = 
		
		<span key={id} className="form-select-group">
			<input
				key={id + '-input'} 
				type={inputType}
				ref={reference}
				id={id}
				webappid={props.id} 
				disabled={true}
				className={` form-control form-control-select ${classes} `}
				onChange={setValue} 
			/>
			<i key={id + '-icon'} className="bi bi-pencil-fill context-menu-icon"></i>
		</span>
		return element;
	}

	function makeTextArea() {
		const element =
			<div key={id} className="webapp-form-item mb-2 ">
				<div key={id + '-label-group'} className="form-label-group">
					<label key={id	+ '-label'} htmlFor={id} className="form-label">{props.title}</label>
					<span key={id + '-toolbar'} className="form-element-toolbar">{toolBar}</span>
				</div>
				<textarea 
					key={id + '-textarea'}
					ref={reference} 
					id={id} 
					webappid={props.id} 
					value={reference.value} 
					readOnly={readOnly} 
					className="form-control" 
					rows={props.rows} 
					onChange={setValue} 
					onFocus={(e) => onFocus(e)}
					onPaste={(e) => onPaste(e)}
					onKeyDown={(e) =>
						{
							if (e.key === 'Enter' && !e.shiftKey && false === true) {
								e.preventDefault();
								x.waf[props.wafId].send();
							}
							// Safari nimmt Buttons ohne "Volle Tastaturkontrolle" nicht in die Tab-Reihenfolge auf,
							// daher wird der Fokus hier beim Tabben aus dem Textfeld manuell an den ersten
							// aktivierten Button im umgebenden Formular weitergegeben (i.d.R. Senden, sonst Leeren/Vorschau).
							if (e.key === 'Tab' && !e.shiftKey) {
								const form = e.target.closest('form');
								const nextButton = form && Array.from(form.querySelectorAll('button:not([disabled])'))[0];
								if (nextButton) {
									e.preventDefault();
									nextButton.focus();
								}
							}
						}
					}
				/>
			</div>
		return element;

	}

	return (
		<React.Fragment key={"form-element-" + id}>
			{makeElement()}
		</React.Fragment>
	);

};
